export default "__VITE_ASSET__B7w093LJ__"